import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem, Typography, Divider } from "@material-ui/core";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import {
  COLOR_FONT,
  COLOR_HIGH,
  COLOR_MID,
  SPACING_BIG,
  SPACING_MED,
  SPACING_XBIG,
  SPACING_XSMALL,
  FONT_SMALL,
} from "../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: SPACING_MED,
    marginRight: SPACING_MED,
    marginBottom: SPACING_BIG,
    color: COLOR_FONT,
    [theme.breakpoints.up("md")]: {
      marginLeft: "15%",
      marginRight: "15%",
    },
  },
  title: {
    marginTop: SPACING_XBIG,
    paddingTop: SPACING_MED,
    color: COLOR_HIGH,
  },
  subtitle: {
    color: COLOR_MID,
    marginTop: SPACING_BIG,
    marginBottom: SPACING_XSMALL,
  },
  list: {
    columnCount: 1,
    columnGap: 0,
    [theme.breakpoints.up("sm")]: {
      columnCount: 2,
    },
    [theme.breakpoints.up("md")]: {
      columnCount: 3,
    },
  },
  listItem: { padding: 0, paddingTop: SPACING_XSMALL, display: "inline-block" },
  listItemFont: { fontSize: FONT_SMALL },
}));

function Specialty() {
  const classes = useStyles();
  const frontend = [
    "React js",
    "HTML / CSS",
    "Redux",
    "JavaScript(ES6+)",
    "TypeScript",
  ];
  const backend = ["Node js", "Express", "Python", "C#", "Java", "C / C++"];
  const database = [
    "PostgreSQL",
    "MongoDB",
    "GraphQL",
    "MySQL",
    "IBM DB2",
    "Firebase",
  ];
  const testing = ["Jest", "Enzyme", "Cypress"];
  const others = ["React Native", "Electron JS", "Docker"];
  const certification = ["IBM Certified Database Associate"];

  const renderLists = (lists) => {
    return lists.map((skill) => {
      return (
        <ListItem className={classes.listItem} key={skill}>
          <Typography
            variant="body1"
            display="block"
            gutterBottom
            className={classes.listItemFont}
          >
            {skill}
          </Typography>
        </ListItem>
      );
    });
  };

  return (
    <div className={classes.root}>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography
          variant="h3"
          component="h3"
          className={classes.title}
          id={"specialty"}
        >
          SPECIALTY
        </Typography>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          FRONTEND
        </Typography>
        <Divider />
        <List dense={false} className={classes.list}>
          {renderLists(frontend)}
        </List>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          BACKEND & DESKTOP
        </Typography>
        <Divider />
        <List dense={false} className={classes.list}>
          {renderLists(backend)}
        </List>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          DATABASE
        </Typography>
        <Divider />
        <List dense={false} className={classes.list}>
          {renderLists(database)}
        </List>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Testing
        </Typography>
        <Divider />
        <List dense={false} className={classes.list}>
          {renderLists(testing)}
        </List>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          OTHERS
        </Typography>
        <Divider />
        <List dense={false} className={classes.list}>
          {renderLists(others)}
        </List>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          CERTIFICATION
        </Typography>
        <Divider />
        <List dense={false} className={classes.list}>
          {renderLists(certification)}
        </List>
      </ScrollAnimation>
    </div>
  );
}

export default Specialty;
